export default "__VITE_ASSET__CRDu9Jgm__"